import I18n from '@js/modules/translations';

// The dated periods a plan place can be set to: the server anchors them the same way (Monday-based weeks).
export const PLAN_PERIOD_COUNTS = {week: 8, month: 12, year: 3};

const pad = (number) => String(number).padStart(2, '0');

export const toIsoDate = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const parseIsoDate = (isoDate) => {
    const [year, month, day] = String(isoDate).slice(0, 10).split('-').map(Number);

    return new Date(year, month - 1, day);
};

export const periodStart = (type, date) => {
    const day = new Date(date.getFullYear(), date.getMonth(), date.getDate());

    if (type === 'week') {
        day.setDate(day.getDate() - ((day.getDay() + 6) % 7));
    } else if (type === 'month') {
        day.setDate(1);
    } else if (type === 'year') {
        day.setMonth(0, 1);
    }

    return day;
};

const addPeriods = (type, start, count) => {
    if (type === 'week') {
        return new Date(start.getFullYear(), start.getMonth(), start.getDate() + 7 * count);
    }
    if (type === 'month') {
        return new Date(start.getFullYear(), start.getMonth() + count, 1);
    }

    return new Date(start.getFullYear() + count, 0, 1);
};

// The coming periods, the current one first; a past one already chosen stays listed so it shows as chosen.
export const periodOptions = (type, now = new Date(), chosenIsoDate = null) => {
    if (!PLAN_PERIOD_COUNTS[type]) {
        return [];
    }

    const first = periodStart(type, now);
    const options = Array.from({length: PLAN_PERIOD_COUNTS[type]}, (_, index) => toIsoDate(addPeriods(type, first, index)));

    const chosen = chosenIsoDate && toIsoDate(periodStart(type, parseIsoDate(chosenIsoDate)));
    if (chosen && !options.includes(chosen)) {
        options.unshift(chosen);
    }

    return options;
};

// On the plan page a week, month or year is a period to choose ("A week"); the ride form keeps "This week"
export const planDateTypeLabel = (type) => (
    PLAN_PERIOD_COUNTS[type] ? I18n.t(`js.ride.plan.periods.types.${type}`) : I18n.t(`js.ride.plan.enums.plan_date_type.${type}`)
);

export const periodLabel = (type, isoDate, locale = I18n.locale) => {
    if (!isoDate) {
        return '';
    }

    const date = parseIsoDate(isoDate);

    if (type === 'week') {
        const withYear = date.getFullYear() !== new Date().getFullYear() ? {year: 'numeric'} : {};

        return I18n.t('js.ride.plan.periods.week', {date: new Intl.DateTimeFormat(locale, {day: 'numeric', month: 'short', ...withYear}).format(date)});
    }
    if (type === 'month') {
        return new Intl.DateTimeFormat(locale, {month: 'long', year: 'numeric'}).format(date);
    }
    if (type === 'year') {
        return String(date.getFullYear());
    }

    return new Intl.DateTimeFormat(locale, {day: 'numeric', month: 'short', year: 'numeric'}).format(date);
};
